import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/setting/airitemtype/`;

const getAirItemTypes = async (params = {}) => {
    return await axios.get(API_URL, { params });
};

const getUniqueCategories = async () => {
    return await axios.get(API_URL + 'categories');
};

const getUniqueTypes = async (category = null) => {
    const params = category ? { category } : {};
    return await axios.get(API_URL + 'types', { params });
};

// Price Quote functions
const createPriceQuote = async (quoteData) => {
    return await axios.post(API_URL + 'quote', quoteData);
};

const getPriceQuotesByUrl = async (url) => {
    return await axios.get(API_URL + 'quote', { params: { url } });
};

const addAirItemType = async (airItemTypeData) => {
    return await axios.post(API_URL, airItemTypeData);
};

const editAirItemType = async (airItemTypeId, updatedData) => {
    return await axios.put(API_URL + airItemTypeId, updatedData);
};

const deleteAirItemType = async (airItemTypeId) => {
    return await axios.delete(API_URL + airItemTypeId);
};

export default {
    getAirItemTypes,
    getUniqueCategories,
    getUniqueTypes,
    addAirItemType,
    editAirItemType,
    deleteAirItemType,
    createPriceQuote,
    getPriceQuotesByUrl
};
